import { Link } from "react-router-dom";

import Reveal from "../../Reveal";
import { howItWorksSections } from "../../../../content/howItWorksSections";

/**
 * Closing call-to-action banner.
 * Translation: Closing call-to-action banner.
 *
 * @returns {JSX.Element} Final CTA section.
 */
const FinalCta = () => {
  const { finalCta } = howItWorksSections;

  return (
    <section id="cta" className="section-block hiw-final-cta">
      <div className="section-shell">
        <Reveal>
          <h2 className="section-heading__title">{finalCta.title}</h2>
          <p className="section-heading__intro">{finalCta.description}</p>
          <div className="cta-row hiw-final-cta__actions">
            <Link className="button button-primary" to={finalCta.primaryCta.href}>
              {finalCta.primaryCta.label}
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCta;
